/**
 * @deprecated Use color-palette.ts instead
 * This palette is being phased out as we roll out the new design system.
 */

export interface ColorMap {
  [key: string]: string;
}

export const colors: ColorMap = {
  bm_pink: '#E9658A',
  bm_soft_pink: '#F3C8D4',
  bm_blue: '#061AB1',
  bm_green: '#91CC70',
  bm_grey: '#A4A6B6',
  bm_hover_blue: '#F3F4FC',
  bm_light_red: '#FCEAE7',
  bm_line_grey: '#E7E7E7',
  bm_soft_background: '#FBFBFE',
  bm_sky_blue: '#00C2F0',
  bm_soft_sky_blue: '#C8E7F2'
};
